import React, { FC } from 'react';

import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Icon from 'components/Icon';

import { Option } from 'components/MultiSelect';
import { AutocompleteRenderGetTagProps } from '@mui/material';

type Props = {
  option: Option;
  getTagProps: AutocompleteRenderGetTagProps;
  index: number;
};

const MultiSelectChip: FC<Props> = ({ option, getTagProps, index }) => (
  <Chip
    label={option.name}
    icon={
      option.icon ? (
        <Box sx={{ pl: '5px' }}>
          <Icon icon={option.icon} />
        </Box>
      ) : undefined
    }
    {...getTagProps({ index })}
  />
);

export default MultiSelectChip;
